import { Typography } from "antd";
import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { defaultSupporterSelectedSelector } from "store/user/(default)/supporter/default_supporter.selector";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const SupporterName = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const selected = useSelector(defaultSupporterSelectedSelector);
  const email = selected?.email;
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return <Typography.Title level={5}>Nhân viên: {email}</Typography.Title>;
};
export default SupporterName;
